<template>
  <div>
    <div class="text-right">
      <setting-table-header
        :default-headers="headers"
        @change="headers = $event"
      />
    </div>

    <v-data-table
      class="nowrap"
      mobile-breakpoint="1"
      :headers="headers"
      :items="bills"
      :search="search"
      select
      dense
      :loading="loading"
    >
      <template v-slot:item.code="{ item }">
        <router-link to @click.native.stop="onView(item)">{{
          item.code
        }}</router-link>
      </template>
      <template v-slot:item.customerPaid="{ item }">
        <div class="nowrap">{{ item.customerPaid | formatMoney }}</div>
      </template>
      <template v-slot:item.date="{ item }">
        <div class="nowrap">{{ item.date | familiarizeDate }}</div>
      </template>
      <template v-slot:item.paymentType="{ item }">
        <div class="nowrap">{{ allPaymentTypes[item.paymentType] }}</div>
      </template>
      <template v-slot:item.type="{ item }">
        <div class="nowrap">{{ allBillTypes[item.type] }}</div>
      </template>
      <template v-slot:item.items="{ item }">
        <router-link
          v-for="data in item.items"
          :key="data.id"
          :to="'/bill/' + data.id"
          >{{ data.title }},</router-link
        >
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" small dark>{{
          allBillStatus[item.status]
        }}</v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import moment from 'moment'
import utils from '@/plugins/utils.js'
import { get } from 'lodash'
const originHeaders = [
  { text: 'Mã Hóa Đơn', align: 'left', sortable: false, value: 'code', show: true },
  { text: 'Tên người nộp tiền', value: 'customerName', show: true },
  { text: 'Đã nộp', value: 'customerPaid', show: true },
  { text: 'Loại', value: 'type', show: true },
  { text: 'Ngày lập', value: 'date', show: true },
  { text: 'Thanh Toán', value: 'paymentType', show: true },

]
export default {
  components: {
    SettingTableHeader,
  },

  props: {
    lead: Object,
  },
  data() {
    return {
      search: '',
      expanded: [],
      loading: false,
      dialog: false,
      viewDialog: false,
      headers: originHeaders,
      draw: false,
      billId: '',
      selected: null,
    }
  },
  computed: {
    ...mapState('constant', [
      'billStatus',
      'billTypes',
      'paymentTypes',
      'billTypes',
    ]),
    ...mapGetters('app', ['department']),
    bills() {
      return get(this.lead, 'bills', [])
    },
    allBillStatus() {
      return this.billStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title'],
        }),
        {}
      )
    },
    allPaymentTypes() {
      return this.paymentTypes.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.status]: cur.title,
        }),
        {}
      )
    },
    allBillTypes() {
      return this.billTypes.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.status]: cur.title,
        }),
        {}
      )
    },
    billData() {
      return this.bill(this.billId)
    },
    total() {
      return (
        this.bills.reduce((total, bill) => {
          return total + bill.customerPaid
        }, 0) || 0
      )
    },
  },
  methods: {
    ...mapActions('bill', [
      'fetchBills',
      'setBill',
      'updateBill',
      'removeBill',
    ]),
    onBillSelected(bill) {
      this.expanded = []
      if (this.billId !== bill.id) {
        this.expanded.push(bill)
        this.billId = bill.id
      } else {
        this.billId = ''
      }
    },
    updateDraw(state) {
      this.draw = state
    },
    onRemove(bill) {
      this.$dialog.confirm({
        title: 'Xóa Hóa đơn này?',
        text:
          'Bạn có chắc chắn muốn xóa hóa đơn này. Dữ liệu này sau khi xóa sẽ không thể phục hồi. Bạn có chắn chắn?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeBill(bill.id)
        },
      })
    },
    onEdit(bill) {
      this.selected = bill
      this.dialog = !this.dialog
    },
    onView(bill) {
      this.selected = bill
      this.viewDialog = !this.viewDialog
    },
    async refresh(query) {
      this.loading = true
      await this.fetchBills({ ...query })
      this.loading = false
    },
    getColor(status) {
      if (status === 'approved') return 'green'
      else if (status === 'rejected') return 'red'
      else if (status === 'opened') return 'blue'
      else if (status === 'canceled') return 'orange'
      else return 'gray'
    },
  },
  created: function () {
    if (this.bills.length === 0) {
      this.refresh('')
    }
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM/YYYY')
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM')
    },
    getName(item) {
      return get(item, 'staff.name')
    },
    formatMoney(data) {
      return utils.formatMoney(data)
    },
  },
}
</script>

<style>
</style>
